import { useSelector } from 'react-redux'
import { createSlice } from '@reduxjs/toolkit'

const excelInitialState = {
  open: false,
  archives: {},
}

const excelSlice = createSlice({
  name: 'excels',
  initialState: excelInitialState,
  reducers: {
    start: (state, { payload: { archiveId } }) => {
      state.open = true
      state.archives[archiveId] = state.archives[archiveId] || {}
      state.archives[archiveId].progress = 0
    },
    addProgress: (state, { payload: { archiveId, newProgress } }) => {
      state.archives[archiveId].progress = newProgress
    },
    finish: (state, { payload: { archiveId } }) => {
      delete state.archives[archiveId]
      if (Object.keys(state.archives).length === 0) {
        state.open = false
      }
    },
  },
})

const { actions } = excelSlice

const selectExcelState = state => state[excelSlice.name]

export function useExcel() {
  const { archives } = useSelector(selectExcelState)
  return archives
}

export function useOpenExcelUI() {
  const { open } = useSelector(selectExcelState)
  return open
}

export function initExcelGeneration(archiveId) {
  return dispatch => {
    dispatch(actions.start({ archiveId }))
  }
}

export function addProgress(archiveId, newProgress) {
  return dispatch => {
    dispatch(actions.addProgress({ archiveId, newProgress }))
  }
}

export function finish(archiveId) {
  return dispatch => {
    dispatch(actions.finish({ archiveId }))
  }
}

export default excelSlice
